import { useEffect, useState } from "react";
import { useSession } from "@clerk/clerk-react";
import { Button } from "@heroui/react";
import { fetchWithAuth } from "shared/api/fetch-with-auth";
import { API_URL } from "constants/index";
import { ChevronRight, Document, Folder } from "assets/icons";
import { SectionHeader } from "..";

export interface DocumentsListProps {
  sharePointFolderId: string;
  sharePointFolderUrl: string;
  refetchDocuments?: any;
}

const DocumentsList = ({
  sharePointFolderId = "",
  sharePointFolderUrl = "",
  refetchDocuments,
}: DocumentsListProps) => {
  const [documents, setDocuments] = useState([]);
  const { session } = useSession();

  useEffect(() => {
    const fetchDocuments = async () => {
      try {
        const response = await fetchWithAuth(
          `${API_URL}/graph/folder/${sharePointFolderId}/files`,
          { method: "GET" },
          session,
        );
        const data = await response.json();
        setDocuments(data);
      } catch (error) {
        console.error("Error fetching documents:", error);
      }
    };

    if (sharePointFolderId) fetchDocuments();
  }, [sharePointFolderId, session, refetchDocuments]);

  return (
    <>
      <SectionHeader
        title="Documenten"
        type="action"
        icon={<Document />}
        action={
          <a
            href={sharePointFolderUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center"
          >
            <Button
              startContent={<Folder className="h-[18px] w-[18px]" />}
              className="h-fit min-w-fit gap-1 rounded-none bg-transparent p-0 text-sm font-medium text-moss-primary hover:bg-transparent"
            >
              Open map in SharePoint
            </Button>
          </a>
        }
      />
      <div className="flex flex-col gap-2.5 px-3">
        {documents.map((doc: any) => (
          <div
            key={doc.id}
            className="flex items-center justify-between gap-2 rounded-md bg-white p-3 shadow-md"
          >
            <a
              href={doc.url}
              target="_blank"
              rel="noopener noreferrer"
              className="grow font-medium"
            >
              {doc.name}
            </a>
            <ChevronRight className="h-[18px] w-[18px] text-neutral-primary/50" />
          </div>
        ))}
      </div>
    </>
  );
};

export default DocumentsList;
